import { render, staticRenderFns } from "./TradeInTab.vue?vue&type=template&id=b21ccaca&scoped=true"
import script from "./TradeInTab.vue?vue&type=script&lang=js"
export * from "./TradeInTab.vue?vue&type=script&lang=js"
import style0 from "./TradeInTab.vue?vue&type=style&index=0&id=b21ccaca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b21ccaca",
  null
  
)

export default component.exports